import { render, staticRenderFns } from "./RegKsph.vue?vue&type=template&id=9fd7f38e&scoped=true"
import script from "./RegKsph.vue?vue&type=script&lang=js"
export * from "./RegKsph.vue?vue&type=script&lang=js"
import style0 from "./RegKsph.vue?vue&type=style&index=0&id=9fd7f38e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd7f38e",
  null
  
)

export default component.exports